import { cn } from "@/lib/utils";

interface SwitchProps {
  checked: boolean;
  onCheckedChange: (v: boolean) => void;
  id?: string;
  disabled?: boolean;
}

/** Accessible toggle switch styled for the studio palette. */
export function Switch({ checked, onCheckedChange, id, disabled }: SwitchProps) {
  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onCheckedChange(!checked);
        }
      }}
      className={cn(
        "relative inline-flex h-11 w-11 shrink-0 cursor-pointer items-center outline-none focus-visible:rounded-full focus-visible:shadow-glow-sm disabled:cursor-not-allowed disabled:opacity-50"
      )}
    >
      <span
        className={cn(
          "absolute left-0 top-1/2 h-6 w-11 -translate-y-1/2 rounded-full border transition-colors",
          checked
            ? "border-studio-accent bg-studio-accent"
            : "border-studio-border bg-studio-card"
        )}
      />
      <span
        className={cn(
          "absolute top-1/2 h-4 w-4 -translate-y-1/2 rounded-full shadow-sm transition-transform",
          checked ? "translate-x-[22px] bg-studio-accent-fg" : "translate-x-[3px] bg-studio-muted"
        )}
      />
    </button>
  );
}
